import { buttons, siteConfig } from "./constants";

export function updateViewMode() {
  if (document.querySelector(".view-option-container") === null) return;

  if (localStorage.getItem(siteConfig.storageView) === "grid") {
    document
      .querySelector(buttons.btnOptionsGrid)
      .dispatchEvent(new Event("click"));
  } else {
    document
      .querySelector(buttons.btnOptionsList)
      .dispatchEvent(new Event("click"));
  }
}

export function updateCategoryButton() {
  const querySelected =
    "#edit-field-consumables-categories .bef-link--selected";
  if (document.querySelector(querySelected) === null) return;

  const categoryButton = document.querySelector(
    ".container-filter-buttons .btn-category"
  );
  const categoryLinkSelected = document.querySelector(querySelected);
  if (categoryLinkSelected.id === "edit-field-consumables-categories-all")
    return;
  const categoryOptionSelected = categoryLinkSelected.closest("li");

  categoryButton.innerHTML = categoryOptionSelected.querySelector(
    ".field--type-string-micon"
  ).innerHTML;
  categoryButton.innerHTML += categoryLinkSelected.innerText;
  categoryButton.innerHTML += ' <i class="micon icomoon-Caret-Small-Down"></i>';
  categoryButton.style.backgroundColor = "transparent";
  categoryButton.style.color = "#000";
}
